import { Routes } from "./routes";

/** Tokenized Snap Squad recap form — no operator login required. */
export function isPublicSquadRecapPath(pathname: string): boolean {
  return pathname.startsWith("/squad-recap/")
    || pathname.startsWith("/snaps/recap/");
}

/** Tokenized public team engagement dashboard — no operator login required. */
export function isPublicTeamEngagementPath(pathname: string): boolean {
  return pathname.startsWith("/public/engagement/");
}

/** Tokenized public game recap — no operator login required. */
export function isPublicGameRecapPath(pathname: string): boolean {
  return pathname.startsWith("/public/recap/");
}

/** Tokenized parking expense form — no operator login required. */
export function isPublicParkingExpensePath(pathname: string): boolean {
  return pathname.startsWith("/parking-expense/");
}

/** Tokenized operator availability form — no operator login required. */
export function isPublicAvailabilityPath(pathname: string): boolean {
  return pathname.startsWith("/availability/");
}

/** Routes that must work without a Cognito session. */
export function isPublicOperatorPath(pathname: string): boolean {
  return pathname === Routes.LOGIN
    || pathname === Routes.TAGBOARD_OAUTH
    || pathname.startsWith("/game/")
    || pathname.includes("/videoboard")
    || isPublicSquadRecapPath(pathname)
    || isPublicTeamEngagementPath(pathname)
    || isPublicGameRecapPath(pathname)
    || isPublicParkingExpensePath(pathname)
    || isPublicAvailabilityPath(pathname);
}
